import { z } from 'zod';
/**
 * The theme fields an entity can set for itself instead of inheriting from its organization.
 *
 * The list is the theme row's own columns, so primary reads its `themeKeys` off this schema rather
 * than keeping a second copy that could drift from the one the route accepts.
 */
export const OrganizationThemeAttributeSchema = z.enum([
    'primaryHexColor',
    'secondaryHexColor',
    'passbookTextColor',
    'passbookLogoUrl',
    'previsitLogoUrl',
    'previsitDomain',
    'previsitFaviconUrl',
    'previsitPageTitle',
    'termsOfUseGsPath',
    'mastheadImageUrl',
    'ssoEnabled',
    'ssoButtonLabel',
    'ssoButtonIconUrl',
]);
/** Which attribute to report overrides for: the answer is per attribute, not per theme. */
export const OrganizationThemeNotInheritingQuerySchema = z
    .object({ attribute: OrganizationThemeAttributeSchema })
    .strict();
//# sourceMappingURL=theme.js.map